import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';
import ChampTexteLong from '../champs/ChampTexteLong';

function SectionMethodologie({
  livrables, phases,
  onAjouterLivrable, onSupprimerLivrable, onModifierLivrable,
  onAjouterPhase, onSupprimerPhase, onModifierPhase,
  moyensOutils, onChangerMoyensOutils,
}) {
  return (
    <>
      {/* ── Livrables ── */}
      <Carte titre="Livrables & garanties" icone="📦">
        <div className="liste-dynamique">
          {livrables.map((liv, idx) => (
            <div key={liv.id} className="liste-dynamique__item">
              <div className="liste-dynamique__item-entete">
                <span className="liste-dynamique__item-num">Livrable {idx + 1}</span>
                <button
                  className="btn btn--danger btn--sm"
                  onClick={() => onSupprimerLivrable(liv.id)}
                >
                  ✕ Supprimer
                </button>
              </div>
              <div className="grille grille--2col">
                <ChampTexte
                  label="Nom du livrable"
                  valeur={liv.nom}
                  onChange={(_, val) => onModifierLivrable(liv.id, 'nom', val)}
                  nom="nom"
                  placeholder="ex : Rapport d'analyse"
                />
                <div>
                  <label htmlFor={`garantie-${liv.id}`} className="champ__label ">
                    Garantie (en semaine)
                  </label>
                  <input
                    id={`garantie-${liv.id}`}
                    className="garantie-input"
                    type="number"
                    value={liv.garantie || ''}
                    onChange={(e) => onModifierLivrable(liv.id, 'garantie', e.target.value)}
                    placeholder="4"
                    min="0"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <button className="btn btn--fantome" style={{ marginTop: 8 }} onClick={onAjouterLivrable}>
          + Ajouter un livrable
        </button>
      </Carte>

      {/* ── Phases / Méthodologie ── */}
      <Carte titre="Méthodologie de réalisation" icone="🗂️">
        <div
          style={{ fontSize: 12, color: 'var(--gris-texte)', marginBottom: 16, fontStyle: 'italic' }}
        >
          Ordonnancement et durée des phases
        </div>
        <div className="liste-dynamique">
          {phases.map((phase, idx) => (
            <div key={phase.id} className="liste-dynamique__item">
              <div className="liste-dynamique__item-entete">
                <span className="liste-dynamique__item-num">Phase {idx + 1}</span>
                <button
                  className="btn btn--danger btn--sm"
                  onClick={() => onSupprimerPhase(phase.id)}
                >
                  ✕ Supprimer
                </button>
              </div>
              <div className="grille grille--2col">
                <ChampTexte
                  label="Désignation de la phase"
                  valeur={phase.designation}
                  onChange={(_, val) => onModifierPhase(phase.id, 'designation', val)}
                  nom="designation"
                  placeholder="ex : Développement Front"
                />
                <ChampTexte
                  label="Nombre de JEH"
                  valeur={phase.nombreJeh}
                  onChange={(_, val) => onModifierPhase(phase.id, 'nombreJeh', val)}
                  nom="nombreJeh"
                  placeholder="ex : 3"
                  chiffresUniquement
                />
                <ChampTexteLong
                  label="Description"
                  valeur={phase.description_phase}
                  onChange={(_, val) => onModifierPhase(phase.id, 'description_phase', val)}
                  nom="description_phase"
                  placeholder="Décrire la phase..."
                  infobulle="Être le plus précis possible : nombre de pages à maquetter, nombre de questions si questionnaire, etc."
                  lignes={2}
                  pleineLargeur
                />
              </div>
            </div>
          ))}
        </div>
        <button className="btn btn--fantome" style={{ marginTop: 8 }} onClick={onAjouterPhase}>
          + Ajouter une phase
        </button>


        {/* ── Moyens et outils techniques utilisés ── */}
        <div style={{ borderTop: '1px solid var(--gris-bord)', paddingTop: 20, marginTop: 24 }}>
          <ChampTexteLong
            label="Moyens et outils techniques utilisés"
            valeur={moyensOutils}
            onChange={(_, val) => onChangerMoyensOutils(val)}
            nom="moyensOutils"
            placeholder="Montrer en quoi les enseignements de l'établissement d'enseignement permettent de répondre à la problématique de l'étude."
            lignes={3}
            pleineLargeur
          />
        </div>
      </Carte>
    </>
  );
}

export default SectionMethodologie;